<template>
  <EcongressLive
    v-if="
      shortLink == 'kardiyolojinobelleri' ||
      shortLink == '25aralikkardiyolojigundemi' ||
      shortLink == 'diyabet360'
    "
  />
  <Live v-else />
</template>
<script>
import Live from './Live2.vue'
import EcongressLive from './custom/genxEcongressLive.vue'

export default {
  name: 'live',
  components: {
    Live,
    EcongressLive
  },
  computed: {
    shortLink() {
      return this.$router.currentRoute.params.shortLink
    }
  },
  methods: {},
  created() {},
  mounted() {}
}
</script>